var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.893,
    height: 75.27,
    viewBox: "0 0 256.893 75.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b,.d{fill:#2fffd1;}.b{fill-rule:evenodd;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.59 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M940.816,261.543v.114a8.177,8.177,0,0,0,2.626,5.909,24.522,24.522,0,0,1,7.39,17.888v.282c0,12.818-8.733,23.523-22.537,23.523-13.24,0-22.678-10.847-22.678-23.805v-.282A24.287,24.287,0,0,1,913,267.167a7.976,7.976,0,0,0,2.635-5.832h0a7.783,7.783,0,0,0-12.68-6.039,38.5,38.5,0,0,0-14.378,30.158v.282c0,21.128,16.762,38.454,39.44,38.454,22.96,0,39.862-17.607,39.862-38.736v-.282a38.093,38.093,0,0,0-14.107-29.841A7.964,7.964,0,0,0,940.816,261.543Z",
    transform: "translate(-888.573 -248.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1016.17,242.744a7.235,7.235,0,1,1,7.235,7.235,7.235,7.235,0,0,1-7.235-7.235",
    transform: "translate(-983.782 -235.509)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 79.132,
    height: 75.062,
    transform: "translate(0 0.208)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M223.839,317.88C203.605,317.88,188,303.2,188,281.643v-.264c0-19.969,14.15-36.368,34.12-36.368,22.218,0,33.195,18.25,33.195,34.384a7.482,7.482,0,0,1-7.538,7.67H204c1.719,11.374,9.786,17.721,20.1,17.721a25.1,25.1,0,0,0,16.531-6.083,5.96,5.96,0,0,1,4.1-1.455,6.3,6.3,0,0,1,6.348,6.48,6.989,6.989,0,0,1-2.116,4.893C242.618,314.309,234.684,317.88,223.839,317.88Zm15.87-41.393c-1.058-10.316-7.141-18.383-17.721-18.383-9.786,0-16.663,7.538-18.118,18.383Z",
    transform: "translate(-188 -245.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M500.992,319.57H500.2c-4.364,0-7.274-2.777-9.125-7.009l-23.276-53.3a12.472,12.472,0,0,1-.926-3.967,8,8,0,0,1,7.935-7.67c4.364,0,6.612,2.512,7.935,5.819l17.986,46.287,18.25-46.552c1.19-2.777,3.306-5.554,7.538-5.554a7.623,7.623,0,0,1,7.8,7.67,9.6,9.6,0,0,1-.926,3.835l-23.276,53.428C508.266,316.661,505.356,319.57,500.992,319.57Z",
    transform: "translate(-396.383 -246.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M776.092,255.694a7.9,7.9,0,0,1,7.934-8.067,8.015,8.015,0,0,1,8.067,8.067v55.279a8,8,0,0,1-16,0Z",
    transform: "translate(-627.444 -246.966)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvio);
export default __webpack_public_path__ + "static/media/evio.2409dc8bd60d4b49b4c4e496b689161b.svg";
export { ForwardRef as ReactComponent };